import {Pipe} from "@angular/core";
import { toKebab } from "../../utils/string-utils";

@Pipe({
    name: 'kebab',
    standalone: false,
})
export class KebabPipe {
  transform(value: string, target?: string) : string {
    return toKebab(value, target);
  }
}
